import { Button } from '@mantine/core';
import { IconCopy } from '@tabler/icons-react';
import { useNavigate } from 'react-router';
import { useModal } from '@ayocore/platform/client/hooks/useModal';
import { DuplicateElitaOrderForm } from './forms/DuplicateElitaOrderForm';

interface Props {
  /** ID сделки-образца. */
  dealId: number;
}

/**
 * Кнопка в заголовке DealView «Создать по образцу» — открывает модалку
 * выбора партнёра и после создания переводит пользователя на новую сделку.
 */
export function DuplicateElitaOrderButton({ dealId }: Props) {
  const navigate = useNavigate();
  const modal = useModal(DuplicateElitaOrderForm);

  const handleClick = () => {
    modal.open(
      {
        title: 'Создать КП по образцу',
        sourceDealId: dealId,
        onCreated: result => {
          modal.close();
          navigate(`/crm/deals/${result.id}`);
        },
        onCancel: () => modal.close(),
      },
      { size: 'md', inputSize: 'sm' }
    );
  };

  return (
    <Button leftSection={<IconCopy size={14} />} size='xs' variant='light' onClick={handleClick}>
      Создать по образцу
    </Button>
  );
}
